import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import AnchorBlack from "../../styles/AnchorBlack";

library.add(fab, faFileAlt);

function homeLinks(props = {}) {
  return (
    <p className="home-links-container">
      <AnchorBlack
        href="https://s3-ap-southeast-1.amazonaws.com/darrelltzjportfolio/documents/darrell_teo_resume.pdf"
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <FontAwesomeIcon icon="file-alt" /> Resume
      </AnchorBlack>
      {" | "}
      <AnchorBlack
        href="https://www.linkedin.com/in/darrelltzj/"
        target="_blank"
        rel="noopener noreferrer"
        className="icon-links"
      >
        <FontAwesomeIcon icon={["fab", "linkedin"]} /> Linkedin
      </AnchorBlack>
      {" | "}
      <AnchorBlack
        href="https://github.com/darrelltzj"
        target="_blank"
        rel="noopener noreferrer"
        className="icon-links"
      >
        <FontAwesomeIcon icon={["fab", "github"]} /> Github
      </AnchorBlack>
    </p>
  );
}

function mapStateToProps(state = {}) {
  // const { navbar } = state
  return {};
}

export default connect(mapStateToProps)(homeLinks);



// WEBPACK FOOTER //
// ./src/components/home/HomeLinks.js